import { Component, OnInit } from '@angular/core';
import { MenuStore } from '../service/menu.store';
import { OnyxEvent } from '../../event/models/event';
import { EventStore } from '../../event/service/event.store';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { User } from '../../auth/models/User';

@Component({
  selector: 'pioneer-event-menu',
  templateUrl: './event-menu.component.html'
})
export class EventMenuComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public eventTitle = 'COMMON.NAV.EVENT_INFORMATION';
  public includeSubNav = true;

  private user: User;

  constructor(
    private eventStore: EventStore,
    private menuStore: MenuStore,
    private eventSearchParameterStore: EventSearchParametersStore,
    private authenticationStore: AuthenticationStore
  ) { }

  ngOnInit() {
    this.menuStore.isReadOnly.subscribe(isReadOnly => {
      this.includeSubNav = isReadOnly;
      this.eventTitle = isReadOnly ? 'COMMON.NAV.EVENT_INFORMATION' : 'COMMON.NAV.EDIT_EVENT';
    });

    this.onyxEvent = new OnyxEvent();
    this.eventStore.selectedEvent.subscribe(value => {
      this.onyxEvent = new OnyxEvent(value);
    });

    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });
  }

  navigateToSearch(): void {
    this.eventSearchParameterStore.updateUrl();
  }

  public hideGroupReservations(): boolean {
    return (this.authenticationStore.isAgencyUser() && !this.onyxEvent.eventProperty.subscriber);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/menus/event-menu/event-menu.component.ts